<template>
  <div class="row py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="col col-md-4 col-lg-4 hidden-sm-down opacity-20">
      <img src="/img/450.png" class="w-100" aria-roledescription="logo" alt="" />
    </div>

    <div class="col-sm-12 col-md-8 col-lg-8 col-xl-7 ml-auto">
      <login-form />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import LoginForm from '@/components/forms/Login';

// @vuese
// Formularz logowania
// @group Login
export default {
  components: { LoginForm },
  computed: mapState({
    appTitle: state => state.system.appTitle
  }),
  mounted() {
    document.title = 'Zaloguj się' + ' - ' + this.appTitle;
  }
};
</script>
